import { useEffect, useState } from 'react'
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import fondo from '../img/chombaverde.webp'

///////////////////////////////////////////
import { useDispatch, useSelector } from 'react-redux'
import {
    loginUsuario,
} from '../Redux/usuarios.js'
import { Link, Navigate, useNavigate } from 'react-router-dom'
//////////////////////////////////////////
import * as yup from 'yup'
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup'
import { UserAuth } from '../context/AuthContext';
import WindowIcon from '@mui/icons-material/Window';
import { toast } from "react-toastify";

const Login = (props) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { signIn, loading, signInWithMicrosoft, user } = UserAuth()
    const [loadingRedirect, setLoadingRedirect] = useState(true); // Bloquea desde el inicio

    const defaultValues = {
        email: '',
        password: ''
    };

    const validationSchema = yup.object().shape({
        password: yup.string().required("Required"),
        email: yup
            .string()
            .email() //el.email es para que valide que realmente este escribiendo un email
            .required("Required")
    });

    const methods = useForm({
        shouldUnregister: false,
        defaultValues,
        resolver: yupResolver(validationSchema),
        mode: "onChange"
    });

    const {
        handleSubmit,
        // reset, 
        // trigger 
    } = methods;

    const [showPassword, setShowPassword] = useState(false);

    const handleMicrosoftSignIn = (event) => {
        event.preventDefault(); // Evita el comportamiento predeterminado del botón
        signInWithMicrosoft();
    };

    useEffect(() => {
        toast.info('Te estamos redirigiendo al nuevo enlace del Portal Codocente...', {
          position: "top-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          closeButton: false,
          theme: "dark"
        });

        const timer = setTimeout(() => {
            window.location.href = "https://portalgestion.ues21.edu.ar/login";
        }, 10100);

        return () => clearTimeout(timer);
    }, []);



    if (user?.email?.length > 0) {
        return <Navigate to="/inicio" />;
        
    }

    return (
        <Grid container component="main" sx={{ height: '100vh' }}>
            <CssBaseline />
            <Grid
                item
                xs={false}
                sm={4}
                md={7}
                sx={{
                    backgroundImage: `url(${fondo})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            />
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <Box
                    sx={{
                        my: 8,
                        mx: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography variant="h5">
                        Bienvenido
                    </Typography>
                    <FormProvider {...methods}>
                        <form>
                            <Box sx={{ mt: 1 }}>
                                <Box sx={{ mt: 3, mb: 2, position: 'relative' }}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        color="primary"
                                        onClick={handleMicrosoftSignIn}
                                        startIcon={<WindowIcon />}
                                        disabled={loadingRedirect}
                                    >
                                        Ingresar con Microsoft
                                    </Button>
                                </Box>
                            </Box>
                        </form>
                    </FormProvider>
                </Box>
            </Grid>
        </Grid>
    )
}

export default Login